<script lang="ts">
    import type {Rec} from 'typings/portaro.be.types';
    import {pipe} from 'core/utils';
    import {loc, recordDetailPath} from 'shared/utils/pipes';

    export let value: Rec;
</script>

<a href={pipe(value, recordDetailPath())}>{pipe(value, loc())}</a>